import React, { FC } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { PageHeader, UserStateComponent } from '../../components';
import { useTranslation } from '../../translations';
import { ProviderLoginButton } from './sociallink/provider';

import './sociallinks.scss';

export const SocialLinks: FC = () => {
  const { ts } = useTranslation();
  return (
    <UserStateComponent>
      <PageHeader>{ts('social_links')}</PageHeader>
      <Row className="justify-content-center">
        <Col className="text-center" lg={8} xs={12}>
          <p>{ts('connect_your_external_accounts_to')}</p>
        </Col>
        <Col xs={12} />
        <Col lg={3} xs={6}>
          <Card>
            <CardBody className="text-center social-link">
              <Row className="justify-content-center">
                <Col className="social-link-logo" lg={8} xs={12}>
                  {ts('placeholder')}
                </Col>
                <Col className="social-link-name" lg={8} xs={12}>
                  {ts('provider')}
                </Col>
                <Col lg={8} xs={12}>
                  <ProviderLoginButton fullText={false} target="sample" />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </UserStateComponent>
  );
};
